import React, { useMemo } from 'react';
import { LinkListArrow } from 'anf-core-react';
import { useDatabridge } from '@xp-utilities/web';
import { TmntText, TmntHtml } from '../Common';
import RewardsLink from './RewardsLink';
import {
  AccountNavMenuLinksPropTypes,
  AccountNavMenuLinksDefaultProps,
} from './props';
import ProfileCompletionBadge from './ProfileCompletionBadge';

function AccountNavMenuLinks({
  isLoggedIn,
  isMobileView,
  links,
  onMyAbercrombieClick,
  onOpenAuthModal,
}) {
  const { accountLinks, rewardsCenterLinks } = useMemo(() => {
    const createDefaultLinks = () => ({ accountLinks: [], rewardsCenterLinks: [] });

    if (!links) return createDefaultLinks();

    return links.reduce((acc, link) => {
      const { text, optionValue: url } = link;
      const key = text?.key;

      if (url?.includes('/RewardsCenterDisplayView')) {
        acc.rewardsCenterLinks.push({ key, ...link });
      } else {
        acc.accountLinks.push({ key, ...link });
      }

      return acc;
    }, createDefaultLinks());
  }, [links]);

  const [isCustomerLoyaltyCallsDisabled] = useDatabridge('flag.customer-loyalty-calls-disable-switches.toasterCoupons', false);

  const handleLinkClick = (url, redirectRoute) => {
    if (url?.includes('/RewardsCenterDisplayView')) return () => onMyAbercrombieClick(url);
    if (url === 'authentication-modal:open') return () => onOpenAuthModal({ isSignInTab: true, redirect: redirectRoute });
    if (
      url?.includes('/UserAccountView')
      || url?.includes('/MySavesView')
      || url?.includes('/myAbercrombie')
    ) return () => window.location.assign(url);

    return null;
  };

  const renderLinkDescription = (descriptionTmnt) => {
    if (!descriptionTmnt?.value) return null;
    if (descriptionTmnt.key === 'LOYALTY_NEXT_REWARD_CASH') return <TmntHtml tmnt={descriptionTmnt} />;
    return <TmntText tmnt={descriptionTmnt} />;
  };

  const renderLinks = (linkSet) => (
    linkSet.map((link) => {
      const {
        text, optionValue: url, description, redirectRoute,
      } = link;

      const tmnt = (
        <TmntText
          testId={`account-nav-link-${text?.key}`}
          tmnt={text}
        />
      );

      const descriptionTmnt = renderLinkDescription(description);

      const linkItem = {
        children: (
          <>
            {tmnt}
            {descriptionTmnt}
          </>
        ),
        key: text?.key,
      };

      const isAccountSettings = text?.key === 'ACT_SETTINGS';

      if (isAccountSettings) {
        linkItem.children = (
          <>
            <span className="account-nav-link-with-badge">
              { tmnt }
              <ProfileCompletionBadge isLoggedIn={isLoggedIn} />
            </span>
            {descriptionTmnt}
          </>
        );
      }

      const onClickHandler = handleLinkClick(url, redirectRoute);

      return onClickHandler
        ? { ...linkItem, onClick: onClickHandler }
        : { ...linkItem, href: url };
    })
  );

  return (
    <div className="account-nav-menu-links">
      {
        rewardsCenterLinks.length > 0 && (
          <>
            <LinkListArrow links={renderLinks(rewardsCenterLinks)} />
            {
              isLoggedIn
              && !isCustomerLoyaltyCallsDisabled()
              && (
                <>
                  <RewardsLink isMobileView={isMobileView} />
                  <hr className="signin-separator" />
                </>
              )
            }
          </>
        )
      }
      <LinkListArrow links={renderLinks(accountLinks)} />
      <hr className="signin-separator" />
    </div>
  );
}

AccountNavMenuLinks.propTypes = AccountNavMenuLinksPropTypes;
AccountNavMenuLinks.defaultProps = AccountNavMenuLinksDefaultProps;

export default AccountNavMenuLinks;
